<template>
  <div class="partener-payment">
    <div class="partener-payment__title">
      <div>
        <h3><span>الاسم:</span> {{ $route.query.name }}</h3>
        <h6 class="mt-3"><span>الرصيد: </span> <b class="text-success"> {{ convertNumber(partenerAccount) }}</b> </h6>
      </div>
      <div>
        <el-button
          plain
          type="primary"
          class="mr-3"
          @click="openAddPartenerPayment = true"
          >إضافة عملية جديدة</el-button
        >
        <el-button
          plain
          type="success"
          class="mr-3"
          @click="print"
          >طباعه كشف الحساب</el-button
        >
        <i @click="$router.push('/parteners')" class="el-icon-back"> </i>
      </div>
    </div>

    <div>
      <!-- <el-date-picker
        v-model="dateRange.start"
        type="date"
        @change="getPartenerPayments()"
        placeholder="من بداية"
        style="width: 200px"
      >
      </el-date-picker>
      <el-date-picker
        v-model="dateRange.end"
        @change="getPartenerPayments()"
        type="date"
        style="width: 200px"
        placeholder="إلي نهاية"
      >
      </el-date-picker> -->
      <el-date-picker
        style="width: 100%"
        @change="getPartenerPayments"
        v-model="dateRange"
        type="daterange"
        range-separator="الي"
        format="yyyy/MM/dd"
        value-format="yyyy-MM-dd"
        start-placeholder="بداية الفترة"
        end-placeholder="نهاية الفترة"
        class="display-mobile-none"
      />
      <el-date-picker
        type="date"
        class="filter-mobile"
        format="yyyy/MM/dd"
        value-format="yyyy-MM-dd"
        @change="getPartenerPayments"
        v-model="startDate"
        placeholder="بداية الفترة"
      />
      <el-date-picker
        type="date"
        class="filter-mobile"
        format="yyyy/MM/dd"
        value-format="yyyy-MM-dd"
        @change="getPartenerPayments"
        v-model="endDate"
        placeholder="نهاية الفترة"
      />
    </div>

    <div class="parteners__list mt-4" id='print' v-show="1==0">
    <br>
         <table >
        <thead>
            <th width="18%"><h3 style="margin:5px;">الاسم</h3></th>
          <td class="text-center"><h3 style="margin:5px;">{{ $route.query.name }}</h3></td>
          <th><h3 style="margin:5px;">الرصيد</h3></th>
          <td><h3 style="margin:5px;">{{ convertNumber(partenerAccount) }}</h3></td>
        </thead>
         </table>
         <br>
      <table >
        <thead>
            <th>المبلغ</th>
          <th>التوع</th>
          <th>التاريخ</th>
          <th>ملاحظه</th>
        </thead>
        <tbody>
          <tr   v-for="payment in payments"   :key="payment.id">
            <td class="text-center">{{ convertNumber(payment.cost) }}</td>
            <td  class="text-center">
               <span  v-if="payment.type == 1" style="color:green;">إيداع</span>
        <span v-else-if="payment.type == 0" style="color:red">سحب</span>
            </td>
            <td>{{payment.created_at | moment("dddd | Do / MM / YYYY | h:mm A") }}</td>
            <td>{{ payment.comment }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="parteners__list mt-4">
      <div
        v-for="payment in payments"
        class="parteners__card"
        :key="payment.id"
      >
        <h5>{{ convertNumber(payment.cost) }} </h5>
        <h6 class="mb-3">{{ payment.comment }}</h6>
        <h6 class="type-1" v-if="payment.type == 1">إيداع</h6>
        <h6 class="type-0" v-else-if="payment.type == 0">سحب</h6>

        <h6 class="mt-3">{{payment.created_at | moment("dddd | Do / MM / YYYY | h:mm A") }}</h6>

        <!-- <div class="text-center mt-2">
          <el-button
            @click="
              $router.push(
                `/parteners/${partener.id}?name=${partener.name}&account=${partener.account}`
              )
            "
          >
            الدفع</el-button
          >
        </div> -->
      </div>
    </div>

    <vs-popup
      class="popup-width-300"
      title="إضافة عمليه جديده"
      :active.sync="openAddPartenerPayment"
    >
      <div class="popup-calender">
        <el-form :model="addPayment" ref="addPayment">
          <h6>نوع العمليه</h6>
          <el-form-item
            style="min-width: 300px"
            prop="type"
            :rules="[{ required: true, message: 'النوع مطلوب' }]"
          >
            <el-select
              style="width: 100%"
              v-model="addPayment.type"
              placeholder=". "
            >
              <el-option
                v-for="item in partenerType"
                :key="item.val"
                :label="item.text"
                :value="item.val"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <h6>
            المبلغ
            <span class="mr-5" v-if="addPayment.cost"
              >( {{ convertNumber(addPayment.cost) }} )</span
            >
          </h6>
          <el-form-item
            style="min-width: 300px"
            prop="cost"
            :rules="[{ required: true, message: 'المبلغ مطلوب' }]"
          >
            <el-input type="number" v-model="addPayment.cost"></el-input>
          </el-form-item>

          <h6>التعليق</h6>
          <el-form-item style="min-width: 300px" prop="comment">
            <el-input v-model="addPayment.comment"></el-input>
          </el-form-item>

          <el-form-item>
            <div>
              <el-button type="primary" @click="onAddPayment('addPayment')">
                إضافة
              </el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import axiosApi from "@/plugins/axios.js";
export default {
  data() {
    return {
      dateRange: null,
      payments: [],
      openAddPartenerPayment: false,
      partenerType: [
        { text: "إيداع", val: 1 },

        { text: "سحب", val: 0 },
      ],
      start: null,
      partener: null,
      partenerAccount: 0,
      addPayment: {},
      end: null,
      startDate: "",
      endDate: "",
    };
  },
  mounted() {
    this.$moment.locale("ar");
    this.getPartenerPayments();
    this.getPartener();
  },
  methods: {
    print(){
       setTimeout(() => {
          // this.$htmlToPaper("pos-invoice80");
           this.$simplePrint('#print');
        }, 200);
    },
    convertNumber(val) {
      if (val > 0) {
        return Number(val).toLocaleString("en-US");
      } else {
        return "";
      }
    },
    onAddPayment(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.saveAddPayment();
        }
      });
    },
    saveAddPayment() {
      const loading = this.$loading({
        lock: true,
        text: "جاري تحميل البيانات",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      axiosApi
        .post("/parteners/payments", {
          ...this.addPayment,
          partener_id: this.$route.params.id,
        })
        .then(() => {
          this.addPayment = {};
          this.openAddPartenerPayment = false;
          this.getPartenerPayments();
          this.getPartener();
          this.$notify({
            title: "تمت العملية بنجاح",
            message: "تم حفظ المبلغ  بنجاح",
            type: "success",
            duration: 1500,
          });
        })
        .finally(() => loading.close());
    },
    getPartenerPayments() {
      const loading = this.$loading({
        lock: true,
        text: "جاري تحميل البيانات",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let params = {
        partener_id: this.$route.params.id,
        start: null,
        end: null,
      };
      if (this.dateRange) {
        params.start = this.dateRange[0];
        params.end = this.dateRange[1];
      }
      if (this.startDate) {
        params.start = this.startDate;
      }
      if (this.endDate) {
        params.end = this.endDate;
      }

      axiosApi
        .get("/parteners-payments", { params })
        .then((res) => {
          this.payments = res.data;
        })
        .finally(() => loading.close());
    },
    getPartener() {
      const loading = this.$loading({
        lock: true,
        text: "جاري تحميل البيانات",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      axiosApi
        .get(`/parteners/${this.$route.params.id}`)
        .then((res) => {
          this.partenerAccount = +res.data.account + +res.data.balance;
        })
        .finally(() => loading.close());
    },
  },
};
</script>

<style lang="scss">
.partener-payment {
  padding: 25px;
  &__title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    div {
      &:first-of-type {
        span {
          font-size: 16px !important;
          font-weight: bold;
          margin: 0 15px 0 0;
        }
      }
    }
    i {
      padding: 9px;
      font-size: 22px;
      background: #fff;
      cursor: pointer;
      border-radius: 50%;
      box-shadow: 1px 3px 8px -2px #eeee;
    }
  }
}
</style>
